export default __webpack_public_path__ + "static/media/collapse.c3997481.webp";